export var addOpacityToColor = function (rgbaColor, opacity) {
    return "" + rgbaColor.split('1)')[0] + opacity + ")";
};
export var changeOpacityOfColor = function (rgbaColor, opacity) {
    return rgbaColor.slice(0, -3) + " " + opacity + ")";
};
